// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "04d1a73",
    "hash": "04d1a73",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "04d1a73",
    "semverString": null
};
/* tslint:enable */
